import { render, staticRenderFns } from "./RegPaymentFailure.vue?vue&type=template&id=55fbfff0"
import script from "./RegPaymentFailure.vue?vue&type=script&lang=js"
export * from "./RegPaymentFailure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports